import { render, staticRenderFns } from "./privacy-march.vue?vue&type=template&id=24abf0f9&scoped=true&"
import script from "./privacy-march.vue?vue&type=script&lang=js&"
export * from "./privacy-march.vue?vue&type=script&lang=js&"
import style0 from "./privacy-march.vue?vue&type=style&index=0&id=24abf0f9&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abf0f9",
  null
  
)

export default component.exports